import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()
import { eventBus } from '@/main'
import emailRejectionsMixin from 'mixins/emailRejectionsMixin.js'
import { withoutRejected } from '@/helpers/emailRejections.js'
import { isUnknownEmailsLimitRejection } from '@/helpers/unknownEmailsLimit.js'

export default {
  mixins: [emailRejectionsMixin],
  data() {
    return {
      add_invited: false,
      participantsCount: 0,
    }
  },
  methods: {
    async mixin_setInvited(new_value) {
      this.add_invited = true

      new_value = new_value.filter(i => i.email)
      let limitRejected = false

      await api.addInvitedParticipant({
        tenderId: this.tender.tenderId,
        invitedUsers: new_value.map(item => ({
          email: item.email,
          contactId: item.contactId,
          organizationId: item.organizationId,
          manualAdded: !!item.manualAdded
        }))
      })
        .then(({ rejected, warnings, errors }) => {
          if (errors.length) {
            limitRejected = isUnknownEmailsLimitRejection(errors)
            throw new Error(errors[0].message)
          }
          // відхилені адреси так і не досягли бази даних, тому вони не відображаються як запрошені
          const accepted = withoutRejected(new_value.map(item => item.email), rejected)
          this.invitedParticipants = new_value.filter(item => accepted.includes(item.email))
          this.$_notifyEmailRejections(rejected, warnings)
        })
        .catch(() => {
          this.$log_error('catch', this)
        })
        .finally(() => {
          eventBus.$emit('changeInvitedList')
        })

      this.add_invited = false
      return limitRejected ? { limitRejected } : undefined
    },
    mixin_addedDevProps(value) {
      const result = this.$_.cloneDeep(this.tender)
      result.members = value
      this.$emit('update:tender', result)
    },
    mixin_getUsers(items) {
      if (!items?.length) {
        return []
      } else {
        let users = []
        items.forEach(el => users.push(...(el?.users || []).map(it => {
          return {
            ...it || {},
            organizationId: el.organizationId,
            supplierRatings: el.supplierRatings,
            organizationTitle: el.organizationTitle,
            organizationUsreou: el.organizationUsreou,
          }
        })))
        return this.mixin_getUnicByEmail(users)
      }
    },
    mixin_getUnicByEmail(items) {
      if (!items) {
        return items
      }
      items = items.map(i => ({...i, email: i.email?.toLowerCase()}))
      return  this.$_.uniqBy(items, function (e) {
        return e.email || e.contactId
      })
    },
    /**
     * Количество подписанных поставщиков по коду классификации
     * @param {*} classificationCode 
     * @returns 
     */
    async mixin_getParticipantsCount(classificationCode) {
      return await api.subcategories(classificationCode)
        .then(res => {
          this.participantsCount = res?.[0]?.participantCount || 0
        })
        .catch(() => {
          this.$log_error('catch', this)
        })
    },
    /**
     * текущий список приглашенных
     */
    async mixin_getInvitedParticipants() {
      await api.invitedParticipants(this.tender.tenderId)
        .then(async res => {
          this.invitedParticipants = res?.map(i => ({
            ...i,
            email: i.email//.toLowerCase()
          })) || []
        })
    },
  },
  computed: {
    subscribedToCategory: {
      get() {
        return this.tender?.members?.subscribedToCategory || []
      },
      set(newValue) {
        this.mixin_addedDevProps({...this.tender.members || {}, subscribedToCategory: newValue})
      }
    },
    accreditedSuppliers: {
      get() {
        return this.tender?.members?.accreditedSuppliers || []
      },
      set(newValue) {
        this.mixin_addedDevProps({...this.tender.members || {}, accreditedSuppliers: newValue})
      }
    },
    // текущий список приглашенных
    invitedParticipants: {
      get() {
        return this.tender?.members?.invitedParticipants || []
      },
      set(newValue) {
        this.mixin_addedDevProps({...this.tender.members || {}, invitedParticipants: newValue})
      }
    },
    subscribersUsers() {
      return this.mixin_getUsers(this.subscribedToCategory)
    },
  }
}
